import { FeatureFlagKey as EncampFeatureFlagKey } from "encamp-shared/src/featureFlags";

import { useTenant } from "./useTenant";

export function useFeatureFlags(): {
  featureFlags: FeatureFlags | undefined;
  loading: boolean;
} {
  const { tenant, loading } = useTenant();
  return { featureFlags: tenant?.featureFlags, loading };
}

export type FeatureFlagKey =
  | "countable-items-ui"
  | "facility-self-assignment"
  | "insights-ui"
  | "module-tierii"
  | "module-waste"
  | "submissions"
  | EncampFeatureFlagKey;

export type FeatureFlags = Record<FeatureFlagKey, boolean>;
